<template>
    <div style="height: 100vh;overflow: scroll">
        <ul class="gongneng">
            <li><h1>产品列表</h1></li>
            <li>
                <el-button type="success" @click="this.$router.push('/backStage_Management/Product/Category')">产品分类</el-button>
                <el-button type="primary" @click="this.$router.push('/backStage_Management/Product/Add')"><i class="el-icon-circle-plus"></i>添加产品</el-button>

            </li>
        </ul>
        <div class="xiala">
            <el-select v-model="value" placeholder="请选择">
                <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                </el-option>
            </el-select>

            <el-input type="text" v-model="input" placeholder="请输入内容" style="width: 200px;margin:0 5px"/>
            <el-button @click="filter(currentPage,value,input)">筛选</el-button>

        </div>

        <div class="table">

            <el-table
                    :data="tableData"

                    border
                    style="width: 100%">
                <el-table-column
                        fixed
                        prop="id"
                        label="编号"
                        width="">
                </el-table-column>
                <el-table-column
                        prop="name"
                        label="产品名称"
                        width="">
                </el-table-column>
                <el-table-column
                        prop="sn"
                        label="产品序号"
                        width="">
                </el-table-column>
                <el-table-column
                        prop="content"
                        label="产品分类"
                        width="">
                </el-table-column>
                <el-table-column
                        prop="addTime"
                        label="添加日期"
                        width="">
                </el-table-column>

                <el-table-column
                        key="slot"
                        label="操作"
                        width="">
                    <template #default="{row}">

                            <el-button @click="handleClick(row)" type="text" size="small">修改</el-button>
                            <el-button @click="deleteClick(row)" type="text" size="small">删除</el-button>

                    </template>
                </el-table-column>

            </el-table>

<!--            <el-row>-->
<!--                <el-col :span="24" style="text-align: center">-->
<!--                    -->
<!--                </el-col>-->
<!--            </el-row>-->
            <el-pagination

                    :page-size="10"
                    layout="prev, pager, next"
                    :default-current-page=currentPage
                    @current-change="handleCurrentChange"
                    :current-page=currentPage
                    :total=total
                    ref="pagination"

            >
            </el-pagination>
        </div>


    </div>
</template>

<script>
    import request from "@/utils/request";
    export default {
        name: "login",
        metaInfo: {
            title: 'Ifcores 管理中心 - 产品中心 | 南京恒创磁电有限公司 - Powered by MeCMS', // set a title
            meta: [{
                // 设置meta信息
                name: '后台管理',
                content: '后台管理系统，管理数据和功能'
            }]
        },
        data() {
            return{
                options: [],
                value:"未分类",
                input:'',
                currentPage:1,
                total:"",
                tableData: [],

            }
        },
        methods: {
            handleClick(row) {
                this.$router.push({path:"/backStage_Management/Product/Add",query:{id:row.id}})
            },
            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) {

                if (this.input==""&&this.value=="未分类"){
                    this.getData(val)
                }else {

                    this.filter(val,this.value,this.input)
                }

            },
            getData(current){
                request.get("/BackStage/productCategory/"+current).then(res => {
                    this.total=res.data.total;
                    this.tableData=res.data.data;
                    this.currentPage=res.data.currentPage

                })
            },
            filter(current,value,input){
                request.get("/BackStage/productCategory/"+current+"/"+value+"/"+input).then(res => {
                    this.total=res.data.total;
                    this.tableData=res.data.data;
                    this.currentPage=res.data.currentPage

                })
            },
            deleteClick(row){

                this.$confirm('此操作将永久删除该型号, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    request.delete("/BackStage/productCategory/"+row.id).then(res => {

                        if (res.code==200){
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            this.getData(this.currentPage)
                        }else {
                            this.$message({
                                type: 'warning',
                                message: '删除失败!'
                            });
                        }
                    })


                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });


            }
        },
        beforeMount(){
            let that=this
                request.get("/BackStage/productCategory").then(res => {

                    for (let i = 0; i <res.data.length ; i++) {
                        let datas={
                            value:res.data[i].catName,
                            lable:i
                        }

                        that.options.push(datas)
                    }

                })
            this.getData(this.currentPage)


        }


    }
</script>

<style lang="less" scoped>

    .el-menu{
        height:100vh
    }
    .gongneng{
        padding: 20px 0;
        border-bottom: 1px solid #cccccc;
        overflow: hidden;
        li:first-child{
            float: left;
            margin-left: 10px;
        }
        li:last-child{
            float: right;
            margin-right: 10px;
        }
    }
    .xiala{
        padding: 10px;
    }
    .el-table .warning-row {
        background: oldlace;
    }

    .el-table .success-row {
        background: #f0f9eb;
    }
</style>